import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ResidenceChangeModalComponent } from './residence-change-modal.component';

@NgModule({
  imports: [
    ResidenceChangeModalComponent // Importar el componente standalone
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ResidenceChangeModalComponent
  ]
})
export class ResidenceChangeModalModule { }
